<template>
    <b-modal
        id="configuratorCallbackModal"
        title="Kérjen visszahívást!"
        hide-footer
    >
        <h5 v-if="done">Köszönjük! Hamarosan visszahívjuk Önt.</h5>

        <b-form v-else @submit.prevent="onSubmit">
            <b-form-group
                label="Teljes név *"
                label-for="callback-name"
                :invalid-feedback="callbackForm.errors.get('name')"
                :state="callbackForm.errors.state('name')"
            >
                <b-form-input
                    id="callback-name"
                    v-model="callbackForm.data.name"
                    type="text"
                    required
                    :state="callbackForm.errors.state('name')"
                />
            </b-form-group>

            <b-form-group
                label="Időpont választása"
                label-for="callback-time-slot"
                :invalid-feedback="callbackForm.errors.get('time_slot')"
                :state="callbackForm.errors.state('time_slot')"
            >
                <!-- TODO(client): confirm callback time-slot options -->
                <b-form-select
                    id="callback-time-slot"
                    v-model="callbackForm.data.time_slot"
                    :options="timeSlots"
                    :state="callbackForm.errors.state('time_slot')"
                />
            </b-form-group>

            <b-form-group
                label="Email *"
                label-for="callback-email"
                :invalid-feedback="callbackForm.errors.get('email')"
                :state="callbackForm.errors.state('email')"
            >
                <b-form-input
                    id="callback-email"
                    v-model="callbackForm.data.email"
                    type="email"
                    required
                    :state="callbackForm.errors.state('email')"
                />
            </b-form-group>

            <b-form-group
                label="Telefonszám *"
                label-for="callback-phone"
                :invalid-feedback="callbackForm.errors.get('phone')"
                :state="callbackForm.errors.state('phone')"
            >
                <b-form-input
                    id="callback-phone"
                    v-model="callbackForm.data.phone"
                    type="tel"
                    pattern="(\+[0-9]+|[0-9]+)"
                    inputmode="numeric"
                    required
                    :state="callbackForm.errors.state('phone')"
                />
            </b-form-group>

            <b-form-group
                label="Megjegyzés"
                label-for="callback-message"
                :invalid-feedback="callbackForm.errors.get('message')"
                :state="callbackForm.errors.state('message')"
            >
                <b-form-textarea
                    id="callback-message"
                    v-model="callbackForm.data.message"
                    :rows="4"
                    maxlength="900"
                    @input="msgLen = ($event || '').length"
                    :state="callbackForm.errors.state('message')"
                />
                <small class="text-muted">{{ msgLen }} / 900 karakter</small>
            </b-form-group>

            <div class="callback-recaptcha mb-3">
                <!-- TODO(client): reCAPTCHA v2 widget — render when config('services.recaptcha.site_key') is provided. No live widget yet (keys client-blocked). -->
            </div>

            <p><small>A küldés gomb megnyomásával elfogadom az Általános Szerződési Feltételeket és az Adatvédelmi nyilatkozatot.</small></p>

            <button
                type="submit"
                class="btn btn-success btn-lg btn-block"
            >
                <i class="fas fa-phone mr-2"></i>Visszahívást kérek
            </button>
        </b-form>
    </b-modal>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import VueForm from "~/form/form";
import { submitToMiniCrm } from "../services/miniCrmService";
import { trackFormSubmission } from "../services/trackingService";
import { namespace } from "vuex-class";

const configuratorModule = namespace("configurator");

@Component
export default class CallbackForm extends Vue {
    @configuratorModule.Action("saveLead") saveLead;

    done = false;
    msgLen = 0;

    // TODO(client): confirm callback time-slot options
    timeSlots = [
        { value: null, text: 'Időpont választása', disabled: true },
        { value: 'Délelőtt (8:00–12:00)', text: 'Délelőtt (8:00–12:00)' },
        { value: 'Délután (12:00–16:00)', text: 'Délután (12:00–16:00)' },
        { value: 'Késő délután (16:00–18:00)', text: 'Késő délután (16:00–18:00)' },
    ];

    callbackForm = new VueForm({
        name: null,
        time_slot: null,
        email: null,
        phone: null,
        message: null,
        gdpr: 1,
    });

    async onSubmit() {
        try {
            const baseMessage = this.callbackForm.data.message || '';
            const timeSlot = this.callbackForm.data.time_slot;
            const combinedMessage = timeSlot
                ? (baseMessage ? `${baseMessage}\nKért időpont: ${timeSlot}` : `Kért időpont: ${timeSlot}`)
                : baseMessage;

            const lead = await this.saveLead(false);

            await Promise.allSettled([
                trackFormSubmission("callback", this.callbackForm.data, {
                    marketing: true,
                    userDataConsent: true,
                    transactionId: `callback-${Date.now()}`,
                }),
                submitToMiniCrm("callback", {
                    company_name: "",
                    first_name: this.callbackForm.data.name || "",
                    last_name: "",
                    email: this.callbackForm.data.email,
                    phone: this.callbackForm.data.phone,
                    message: combinedMessage,
                    gdpr: this.callbackForm.data.gdpr,
                    url: lead.publicUrl,
                }),
            ]);

            this.done = true;
        } catch (error) {
            console.error("Error during callback form submission:", error);
        }
    }
}
</script>
